import { Component } from '@angular/core';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { NavController, NavParams } from 'ionic-angular';
import { EditAthleteData } from '../../pages/edit-athlete-data/edit-athlete-data';
import { IterableDiffers, DoCheck } from '@angular/core';

@Component({
    selector: 'scoreboard-name',
    templateUrl: 'scoreboard-by-name.html'
  })

  export class ScoreBoardName {

    differ: any;
    athletesArray = [];

      constructor (private storage: StorageProvider,
        private navCtrl: NavController, private navParams: NavParams, differs: IterableDiffers) {
        this.differ = differs.find([]).create(null);
        this.getArray();
      }

      ngDoCheck() {
        const change = this.differ.diff(this.athletesArray);
        
        this.sortArray();
        console.log("change");
        
      }

      async getArray() {
        this.athletesArray = this.athletesArray.concat(this.navParams.get('arr'));
        
        console.log("ath arr " + JSON.stringify(this.athletesArray));
      }

      onBackMenu() {
        this.athletesArray.length = 0;
        
        this.navCtrl.pop();
      }

      sortArray(){
        let arr;

        arr = this.athletesArray.sort((a, b) => a.time > b.time && 1 || -1);
        for(let i = 0; i < arr.length; i++){
            arr[i].place = 0;
        }

        for(let i = 0; i < arr.length; i++){
            arr[i].place = i + 1;
        }

        console.log("arr sorted" + JSON.stringify(arr));
        
        this.athletesArray = arr;
      }

      openEditWindow(athlete){
          this.navCtrl.push(EditAthleteData, {ath: athlete});
          console.log("open edit window");
      }
  }


// WEBPACK FOOTER //
// /src/components/scoreboard-by-name/scoreboard-by-name.ts